import React, { useMemo, useState } from "react";
import { BrandWordmark } from "./BrandArtwork";

export default function LayoutShell({
  children,
  mode = "admin",
  modeSwitch,
  navItems = [],
  activeNav,
  onNavChange,
  signedInName,
  onLogout,
}) {
  const isUserMode = mode === "user";
  const [navOpen, setNavOpen] = useState(false);
  const groupedNav = useMemo(() => {
    return navItems.reduce((groups, item) => {
      const key = item.tag || "Panels";
      groups[key] = groups[key] || [];
      groups[key].push(item);
      return groups;
    }, {});
  }, [navItems]);

  return (
    <div className={`console-shell console-shell--${mode}`}>
      <header className="app-header">
        <div className="app-header-brand">
          <button className="nav-toggle" type="button" onClick={() => setNavOpen((open) => !open)} aria-label="Toggle navigation">
            <span />
            <span />
            <span />
          </button>
          <BrandWordmark compact subtitle="" />
        </div>
        <div className="app-header-actions">
          {modeSwitch}
          <div className="signed-in-chip">
            <span>Signed in</span>
            <strong>{signedInName}</strong>
          </div>
          {onLogout ? <button className="header-logout" type="button" onClick={onLogout}>Logout</button> : null}
        </div>
      </header>

      <div className={`console-frame ${navOpen ? "nav-open" : ""}`}>
        <aside className="side-nav">
          <div className="side-nav-heading">{isUserMode ? "Athlete panels" : "Admin panels"}</div>
          {Object.entries(groupedNav).map(([group, items]) => (
            <div className="side-nav-group" key={group}>
              <div className="side-nav-group-label">{group}</div>
              {items.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  className={activeNav === item.key ? "active" : ""}
                  onClick={() => {
                    onNavChange?.(item.key);
                    setNavOpen(false);
                  }}
                >
                  <strong>{item.label}</strong>
                  <span>{item.description}</span>
                </button>
              ))}
            </div>
          ))}
        </aside>
        <main className="console-main">
          <div className="console-content">
            {children}
          </div>
          <footer className="site-legal-links site-legal-links--console">
            <a href="/privacy">Privacy Policy</a>
            <a href="/terms">Terms and Conditions</a>
          </footer>
        </main>
      </div>
    </div>
  );
}
